import React, { useEffect, useState } from "react";
import { Icon } from "semantic-ui-react";

import "components/DetailsCard/DetailsCard.scss";
import { Element } from "components/ReactScroll/index";
import { classNames } from "utils/common";

import type { PropsWithChildren } from "react";

interface ConditionalWrapInterface extends PropsWithChildren {
  condition: boolean;
  wrap: (children: React.ReactNode) => React.ReactNode;
}

type DetailsCardsProps = {
  title: string | React.ReactNode;
  sectionMenuId?: string;
  icon?: string;
  button?: boolean;
  textColor?: string;
  isExpanded?: boolean;
  borderColor?: string;
  containerStyle?: string;
  backgroundColor?: string;
  showExpandArrow?: boolean;
  children?: React.ReactNode;
  isChecklistTitle?: boolean;
  rightContent?: React.ReactNode;
};

export const ConditionalWrap = ({ condition, wrap, children }: ConditionalWrapInterface) => (condition ? wrap(children) : children);

export const DetailsCard = ({
  icon,
  title,
  sectionMenuId,
  rightContent,
  children,
  isExpanded = true,
  showExpandArrow = true,
  button = false,
  containerStyle = "",
  backgroundColor,
  borderColor,
  textColor,
  isChecklistTitle = false
}: DetailsCardsProps) => {
  const detailsCardClasses = classNames({ button });
  const [showCardDetails, setShowCardDetails] = useState(isExpanded);

  const toggleCardDetails = () => setShowCardDetails(previous => !previous);

  useEffect(() => {
    setShowCardDetails(isExpanded);
  }, [isExpanded]);

  return (
    <Element id={sectionMenuId} className={`DetailsCards-container ${detailsCardClasses} ${containerStyle}`}>
      <div className="row">
        <ConditionalWrap
          condition={isChecklistTitle}
          wrap={children => (
            <div className="expand-bar" style={{ ...(borderColor && { border: `1px solid ${borderColor}` }), backgroundColor, color: textColor }}>
              {children}
            </div>
          )}
        >
          {icon && <Icon className={icon} style={{ ...(isChecklistTitle && { color: textColor }) }} />}
          <h3 className={isChecklistTitle ? "checklist-title" : ""}>{title}</h3>
          {showExpandArrow && <Icon className={`chevron ${showCardDetails ? "down" : "right"} pointer`} onClick={toggleCardDetails} />}
        </ConditionalWrap>
        {rightContent}
      </div>
      <div className={showCardDetails ? "show" : "hide"}>{children}</div>
    </Element>
  );
};
